import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import { t } from 'i18next';

import { PricingConfigsFilterKey } from 'support/types/filterKeys';
import { PropertyFilter, PropertyFilterType, SearchPropertyFilter } from 'support/types/filters';

export const getDefaultFilterConfig = (): Array<PropertyFilter | SearchPropertyFilter> => [
  {
    key: PricingConfigsFilterKey.partnerId,
    type: PropertyFilterType.dropdown,
    label: t('priceList:filters.partnerId.label'),
    Icon: BuildingOfficeIcon,
    value: '',
    dropDownOptions: {
      dropdownValues: [],
    },
  },
  {
    key: PricingConfigsFilterKey.name,
    type: PropertyFilterType.search,
    value: '',
    placeholder: t('priceList:filters.searchByName.placeholder'),
  } as SearchPropertyFilter,
];
